import { render, staticRenderFns } from "./recbuysti.vue?vue&type=template&id=e115d694&scoped=true&"
import script from "./recbuysti.vue?vue&type=script&lang=js&"
export * from "./recbuysti.vue?vue&type=script&lang=js&"
import style0 from "./recbuysti.vue?vue&type=style&index=0&id=e115d694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e115d694",
  null
  
)

export default component.exports